<template lang="pug">
div.sidebar-banner.sidebar-banner--live(v-if='isBannerActive || isPlanActive')
  div.sidebar-banner__heading
    span.sidebar-banner__heading-icon
      img.sidebar-banner__heading-icon-img(src='/src/images/prtimes-jp/html/icon_sidebar-live-header.svg', alt='PR TIMES LIVE')
    a.sidebar-banner__heading-link(href='/tv')
      h4.sidebar-banner__heading-text PR TIMES LIVE
  template(v-if='isBannerActive')
    AddLiveBannerElement(:value-props.sync='bannerValue')
  template(v-if='isPlanActive')
    AddLivePlanElement(:value-props.sync='planValue')

</template>

<script>
import AddLiveBannerElement from './addLiveBannerElement';
import AddLivePlanElement from './addLivePlanElement';

export default {
  name: 'AddLiveElement',
  components: {
    AddLiveBannerElement,
    AddLivePlanElement
  },
  props: {
    bannerValueProps: {
      type: Object,
      default: () => {}
    },
    planValueProps: {
      type: Array,
      default: () => []
    },
    isBannerActiveProps: {
      type: Boolean,
      default: false
    },
    isPlanActiveProps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isBannerActive: false,
      isPlanActive: false
    };
  },
  computed: {
    bannerValue: {
      get () {
        return this.bannerValueProps;
      },
      set (newValue) {
        this.$emit('update:bannerValueProps', newValue);
      }
    },
    planValue: {
      get () {
        return this.planValueProps;
      },
      set (newValue) {
        this.$emit('update:planValueProps', newValue);
      }
    }
  },
  watch: {
    isBannerActiveProps (newValue) {
      this.isBannerActive = newValue;
    },
    isPlanActiveProps (newValue) {
      this.isPlanActive = newValue;
    }
  }
};
</script>
